import React from "react";

const Test = () => {
	return (
		<div className="container">
			{/* Add a cross button */}
			<iframe
				title="Magazine"
				className="mobileMag"
				frameborder="0"
				allowTransparency="true"
				allowFullscreen="true"
				src="https://online.visual-paradigm.com/share/book/ocs-magazine-2022-08-26-18kzn3hlw?p=1"
			></iframe>
		</div>
	);
};

export default Test;
